import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import getCampaignImages from "../services/getCampaignImages.service";

import "react-responsive-carousel/lib/styles/carousel.min.css";

export default function useCampaignImages() {
  const {
    i18n: { language },
  } = useTranslation();
  const [campaignImages, setCampaignImages] = useState([]);

  const fetchImages = () => {
    try {
      let p = async () => {
        const donation_campaign_images = await getCampaignImages({
          locale: language,
        });
        setCampaignImages(donation_campaign_images);
      };
      p();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchImages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    campaignImages,
  };
}
